var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import qs from 'qs';
// import { isDevelopment } from '@/utils/util';
import { MOCK_TOKEN, UNAUTH_CODE, BASE_URL } from '@/constants';
import Toast from '@/components/toast';
import { isTest, isLZWKAPP } from '@/utils/util';
import { AxiosCache } from '@/utils/axios.cache';
var axiosCahce = new AxiosCache();
var isUseTestMockToken = false;
var SERVICE_BASE_URL = BASE_URL;
// let PRODUCTION_ENV_HOST = onlineDomain;
var TEST_DEV_URL = 'https://dbg.weike.fm';
if (isTest()) {
    // SERVICE_BASE_URL = PRODUCTION_ENV_HOST;
    SERVICE_BASE_URL = TEST_DEV_URL;
    isUseTestMockToken = false;
}
// 开发使用配置的token
var WHITLE_LIST_AUTH = ['/integral/next'];
function isInWhiteList() {
    return WHITLE_LIST_AUTH.some(function (item) {
        return window.location.pathname.indexOf(item) > -1;
    });
}
export var CancelRequestMethod;
axios.interceptors.request.use(function (config) {
    var _this = this;
    return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
        var token, cancelToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    token = '';
                    cancelToken = axios.CancelToken;
                    if (isLZWKAPP() && window.localStorage.getItem('_token') && window.localStorage.getItem('_token') !== '') {
                        config.headers.common.Authorization = window.localStorage.getItem('_token');
                    }
                    if (!isUseTestMockToken) return [3 /*break*/, 1];
                    _a = MOCK_TOKEN;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, new Promise(function (resolve) {
                        return window.Session.getToken(function (_a) {
                            var token = _a.token;
                            return resolve(token);
                        });
                    })];
                case 2:
                    _a = _b.sent();
                    _b.label = 3;
                case 3:
                    token = _a;
                    if (config.method === 'post' || config.method === 'POST') {
                        if (!config.headers['Content-Type']) {
                            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                            config.data = qs.stringify(config.data);
                        }
                    }
                    if (!config.params) {
                        config.params = {};
                    }
                    CancelRequestMethod = axios.CancelToken.source();
                    if (!isLZWKAPP() || (isLZWKAPP() && !isInWhiteList())) {
                        config.params.token = token;
                    }
                    resolve(config);
                    return [2 /*return*/];
            }
        });
    }); });
});
axios.interceptors.response.use(function (res) {
    return new Promise(function (resolve, reject) {
        if (res.data.code === 0) {
            return resolve(res);
        }
        if (res.data.code === UNAUTH_CODE) {
            Toast.info(res.data.msg);
            setTimeout(function () {
                window.location.replace(BASE_URL + "/account3/myaccount");
            }, 1500);
            return;
        }
        reject({
            code: res.data.code,
            message: res.data.msg,
            status: res.status,
            data: res.data.data
        });
    });
});
axios.defaults.baseURL = SERVICE_BASE_URL;
var Request = /** @class */ (function () {
    function Request() {
    }
    Request.get = function (url, config) {
        return axios.create({
            adapter: function (config) {
                delete config.adapter;
                var data = axiosCahce.getCache(config);
                if (data) {
                    return data;
                }
                var res = axios(config);
                axiosCahce.setCache(config, res);
                return res;
            }
        }).get(url, config).then(function (data) { return data.data; });
    };
    Request.post = function (url, data, config) {
        return axios.post(url, data, config).then(function (data) { return data.data; });
    };
    return Request;
}());
export default Request;



//////////////////
// WEBPACK FOOTER
// ./src/services/axios.config.ts
// module id = 193
// module chunks = 39